export default __webpack_public_path__ + "static/media/Haris_Bin_Rafat.11d9af7e.png";